import { render, staticRenderFns } from "./Calculations.vue?vue&type=template&id=ff490f70&scoped=true&"
import script from "./Calculations.vue?vue&type=script&lang=js&"
export * from "./Calculations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff490f70",
  null
  
)

export default component.exports